var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgInfo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5 4.90001C22.9 3.72001 25.16 3.72001 26.52 4.90001L29.68 7.60001C30.28 8.10001 31.42 8.52001 32.22 8.52001H35.62C37.74 8.52001 39.48 10.26 39.48 12.38V15.78C39.48 16.58 39.9 17.7 40.4 18.3L43.1 21.46C44.28 22.86 44.28 25.12 43.1 26.48L40.4 29.64C39.9 30.24 39.48 31.36 39.48 32.16V35.56C39.48 37.68 37.74 39.42 35.62 39.42H32.22C31.42 39.42 30.3 39.84 29.7 40.34L26.54 43.04C25.14 44.22 22.88 44.22 21.52 43.04L18.36 40.34C17.76 39.84 16.62 39.42 15.84 39.42H12.34C10.22 39.42 8.47999 37.68 8.47999 35.56V32.14C8.47999 31.36 8.07999 30.22 7.57999 29.64L4.87999 26.46C3.71999 25.08 3.71999 22.84 4.87999 21.46L7.57999 18.28C8.07999 17.68 8.47999 16.56 8.47999 15.78V12.4C8.47999 10.28 10.22 8.54001 12.34 8.54001H15.8C16.6 8.54001 17.72 8.12001 18.32 7.62001L21.5 4.90001Z",
    stroke: "#3772FF",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M24 16.26V25.92",
    stroke: "#3772FF",
    strokeWidth: 1.8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M23.989 32H24.007",
    stroke: "#3772FF",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfo);
export default __webpack_public_path__ + "static/media/info.3c75f0dc9303eae241ecfbc1fbe4b6c3.svg";
export { ForwardRef as ReactComponent };